import { render, staticRenderFns } from "./toBeDelivered.vue?vue&type=template&id=6971270c&scoped=true&"
import script from "./toBeDelivered.vue?vue&type=script&lang=js&"
export * from "./toBeDelivered.vue?vue&type=script&lang=js&"
import style0 from "./toBeDelivered.vue?vue&type=style&index=0&id=6971270c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6971270c",
  null
  
)

export default component.exports